import axios from "axios";

const HOST = process.env.REACT_APP_HOST;

const getUsers = async (token: string) => {
  const getUsersURL = `${HOST}/api/users`;
  const config = {
    headers: { Authorization: token }
  }

  const res = await axios.get(getUsersURL, config);

  return res.data;
};

export { getUsers }